import { Endpoint } from '../endpoint';
import {
  OrgBoardResponse,
  OrgBoardRevisionsResponse,
  OrgBoardSeniorResponse,
  OrgBoardSortResponse,
  OrgBoardTemplateResponse,
  OrgId,
  OrgRevId,
  OrgTemplateId,
} from '@business/entities/org_board';
import { CompanyId } from '@business/entities/companies';

export function fetchOrgBoard() {
  return Endpoint.get<OrgBoardResponse[]>(`@makh/org-board`);
}

export function fetchOrgBoardPreview(id: OrgTemplateId) {
  return Endpoint.get<OrgBoardResponse[]>(`@makh/org-board/preview-template/${id}`);
}

export function createOrgBoard(companyId: CompanyId, orgBoard: Partial<OrgBoardResponse>) {
  return Endpoint.post<OrgBoardResponse[]>(`@makh/org-board/${companyId}`, { data: { ...orgBoard } });
}

export function createBlankBoard() {
  return Endpoint.post<OrgBoardResponse[]>(`@makh/org-board/new-blank-board`);
}

export function createOrgBoardPositionName(id: OrgId, orgBoard: Partial<OrgBoardResponse>) {
  return Endpoint.post<OrgBoardResponse[]>(`@makh/org-board/add-org-board-position-name/${id}`, { data: { ...orgBoard } });
}

export function useOrgBoardTemplate(id: OrgTemplateId) {
  return Endpoint.post<OrgBoardResponse[]>(`@makh/org-board/use-org-board/${id}`);
}

export function updateOrgBoard(id: OrgId, orgBoard: Partial<OrgBoardResponse>) {
  return Endpoint.patch<OrgBoardResponse[]>(`@makh/org-board/${id}`, { data: { ...orgBoard } });
}

export function changeOrgBoard(id: CompanyId) {
  return Endpoint.post<OrgBoardResponse[]>(`@makh/org-board/change-board/${id}`);
}

export function updateOrgBoardBump(id: OrgId, orgBoard: Partial<OrgBoardResponse>) {
  return Endpoint.patch<OrgBoardResponse[]>(`@makh/org-board/update-bump/${id}`, { data: { ...orgBoard } });
}

export function updateOrgBoardRootAlign(id: OrgId, orgBoard: Partial<OrgBoardResponse>) {
  return Endpoint.patch<OrgBoardResponse[]>(`@makh/org-board/update-root-align/${id}`, { data: { ...orgBoard } });
}

export function updateMoveBoard(id: OrgId, orgBoard: Partial<OrgBoardResponse>) {
  return Endpoint.patch<OrgBoardResponse[]>(`@makh/org-board/update-move-board/${id}`, { data: { ...orgBoard } });
}

export function updateSortDetails(id: OrgId, orgBoard: OrgBoardSortResponse) {
  return Endpoint.patch<OrgBoardResponse[]>(`@makh/org-board/update-sort-details/${id}`, { data: { ...orgBoard } });
}

export function deleteOrgBoard(OrgId: OrgId) {
  //   return Endpoint.delete<void>(`@makh/org-board/${OrgId}`);
  return Endpoint.delete<OrgBoardResponse[]>(`@makh/org-board/${OrgId}`);
}

export function deleteOrgBoardDetail(OrgId: OrgId, id: OrgId) {
  //   return Endpoint.delete<void>(`@makh/org-board/${OrgId}`);
  return Endpoint.delete<OrgBoardResponse[]>(`@makh/org-board/orgboard-details/${OrgId}`, { data: { id } });
}

export function deleteBoardPositionName(orgId: OrgId, childOrgId: OrgId, nameIndex: number) {
  return Endpoint.delete<OrgBoardResponse[]>(`@makh/org-board/remove-org-board-position-name/${orgId}`, { data: { id: childOrgId, nameIndex } });
}

export function fetchOrgBoardSenior(orgId: OrgId) {
  return Endpoint.get<OrgBoardSeniorResponse[]>(`@makh/org-board/seniors/${orgId}`);
}

export function updateOrgBoardSenior(id: OrgId, orgBoard: Partial<OrgBoardResponse>) {
  return Endpoint.patch<OrgBoardResponse[]>(`@makh/org-board/update-senior/${id}`, { data: { ...orgBoard } });
}

export function fetchOrgBoardDetails(id: OrgId) {
  return Endpoint.get<OrgBoardResponse[]>(`@makh/org-board/org-details/${id}`);
}

export function updateOrgBoardVFP(id: OrgId, orgBoard: Partial<OrgBoardResponse>) {
  return Endpoint.patch<OrgBoardResponse[]>(`@makh/org-board/update-vfp/${id}`, { data: { ...orgBoard } });
}

export function fetchOrgBoardRevisions() {
  return Endpoint.get<OrgBoardRevisionsResponse[]>(`@makh/org-board/revisions`);
}

export function fetchOrgBoardRevision(id: OrgRevId) {
  return Endpoint.get<OrgBoardResponse[]>(`@makh/org-board/revision/${id}`);
}

export function fetchOrgBoardTemplates() {
  return Endpoint.get<OrgBoardTemplateResponse[]>(`@makh/org-board/templates`);
}
